// @flow
import React, { useState, useEffect } from "react";
import {
  Button,
  FormGroup,
  Label,
  Input,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import Octicon, { Info } from "@githubprimer/octicons-react";
import { toast } from "react-toastify";
import Section from "../../components/Section";
import { updateField } from "../../../redux/actions/configActions";
import categoryService from "../../../services/api/categoryService";
import Categories from "./Categories";

export function TemplateSettings() {
  const [categories, setCategories] = useState(null);
  const [categoriesModal, setCategoriesModal] = useState(false);
  const dispatch = useDispatch();
  const config = useSelector(state => state.configReducer.config);

  /**
   * This function will be called by the child categories component to update this component's categories array
   * in case of change
   * @param {*} updatedCategories
   */
  function updateCategories(updatedCategories) {
    setCategories(updatedCategories);
  }

  function handleChange(event) {
    dispatch(updateField({ [event.target.name]: event.target.value }));
  }

  async function toggle() {
    setCategoriesModal(!categoriesModal);
  }
  useEffect(() => {
    async function fetchCategories() {
      const [res, err] = await categoryService.getCategories();
      if (err) {
        toast.error(`Error: ${  err.message}`, {
          bodyClassName: "text-danger"
        });
      }
      setCategories(res.data);
    }
    fetchCategories();
  }, []);

  let categoryOptions;

  if (!categories) {
    categoryOptions = (
      <option disabled value="">
        -- Loading --
      </option>
    );
  } else if (categories.length > 0) {
    categoryOptions = categories.map(category => (
      <option value={category._id}>{category.name}</option>
    ));
    categoryOptions.unshift(
      <option value="" disabled selected>
        -- Choose category --
      </option>
    );
  } else {
    categoryOptions = (
      <option value="" disabled selected>
        -- No categories available --
      </option>
    );
  }

  return (
    <Section title="Template settings" isOpen>
      <FormGroup row>
        <Label for="templateName" sm={2}>
          Template name
        </Label>
        <Col sm={10}>
          <Input
            required
            value={config.templateName}
            type="text"
            name="templateName"
            id="templateName"
            onChange={handleChange}
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for="eventName" sm={2}>
          Category
        </Label>
        <Col sm={10}>
          <div className="d-flex justify-content-inline">
            <Input
              required
              value={config.category}
              type="select"
              name="category"
              id="category"
              className="dropdown-black"
              onChange={handleChange}
            >
              {categoryOptions}
            </Input>
            <Button
              style={{ marginLeft: "1rem" }}
              size="sm"
              className="btn-black"
              outline
              type="button"
              color="dark"
              onClick={toggle}
            >
              <Octicon size="medium" icon={Info} />
            </Button>
          </div>
        </Col>
      </FormGroup>

      <Modal isOpen={categoriesModal} toggle={toggle}>
        <ModalHeader>Manage categories</ModalHeader>
        <ModalBody>
          <Categories data={categories} onChange={updateCategories} />
        </ModalBody>
        <ModalFooter>
          <Button outline className="btn-black" color="dark" onClick={toggle}>
            Done
          </Button>
        </ModalFooter>
      </Modal>
    </Section>
  );
}
export default TemplateSettings;



// WEBPACK FOOTER //
// ./src/views/template/template-form-sections/TemplateSettings.jsx